import { memo } from 'react';
import { useMatch } from 'react-router-dom';

import { Dock } from '@/components/ui/daisy/dock';
import { ShellNavItemProps } from '@/utils/app-shell/getAppShellNavItems';

function ShellDockItem({
  href,
  activePath,
  icon: Icon,
  label,
}: ShellNavItemProps) {
  const isActive = !!useMatch(activePath);

  return (
    <Dock.Item href={href} active={isActive}>
      <Icon className="size-6" strokeWidth="2.2" />
      <Dock.Label>{label}</Dock.Label>
    </Dock.Item>
  );
}

export default memo(ShellDockItem);
